import { ColDef } from "ag-grid-community";
import { useMemo } from "react";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { withFraction32 } from "@/utils/fraction";
import { BundleRow } from "../models/types";

const formatDuration = (minutes: number | null): string => {
	if (minutes === null) return "-";
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;
	if (hours > 0) {
		return `${hours}h ${mins}m`;
	}
	return `${mins}m`;
};

export const useTableData = () => {
	const columnDefs = useMemo(
		(): ColDef<BundleRow>[] => [
			{
				field: "PartNumber",
				headerName: "Part #",
				minWidth: 100,
				flex: 1,

				valueFormatter: (params) => params.value ?? "-",
			},
			{
				field: "AvgLength",
				headerName: "Avg Length",
				headerTooltip: "Average piece length of the bundle",
				wrapHeaderText: true,
				autoHeaderHeight: true,
				minWidth: 80,
				flex: 1,

				valueFormatter: (params) => withFraction32(params.value, "-"),
			},
			{
				field: "StartTime",
				headerName: "Start",
				minWidth: 120,
				flex: 1,

				valueFormatter: (params) =>
					params.value ? dxtToLocalServerTime(params.value, "MM/dd HH:mm") : "",
			},
			{
				field: "EndTime",
				headerName: "End",
				minWidth: 120,
				flex: 1,

				valueFormatter: (params) =>
					params.value ? dxtToLocalServerTime(params.value, "MM/dd HH:mm") : "",
			},
			{
				field: "DurationMinutes",
				headerName: "Duration",
				minWidth: 90,
				flex: 1,

				valueFormatter: (params) => formatDuration(params.value),
			},
			{
				field: "BarCount",
				headerName: "Good Pieces",
				wrapHeaderText: true,
				autoHeaderHeight: true,
				minWidth: 80,
				flex: 1,

				valueFormatter: (params) =>
					params.value && params.value > 0 ? params.value : "",
			},
			{
				field: "LayerCount",
				headerName: "Layers",
				minWidth: 80,
				flex: 1,

				valueFormatter: (params) => params.value ?? "-",
			},
			{
				field: "LayerCountPreset",
				headerName: "Preset",
				minWidth: 80,
				flex: 1,

				valueFormatter: (params) => params.value ?? "-",
			},
		],
		[],
	);

	return { columnDefs };
};
